export default {
    nav: {
        brand: 'travellingdominika',
        services: 'Services',
        portfolio: 'Portfolio',
        contact: 'Contact',
    },
    hero: {
        taglineLabel: 'I AM',
        taglineTitle: 'Dominika',
        taglineSubLine1: 'Content creator',
        taglineSubLine2: 'that captures attention.',
        socialsLabel: 'GET TO KNOW ME',
    },
    intro: {
        label: 'ABOUT',
        greet: 'Hi / hello!',
        title: "I'm Dominika.",
        body1: 'I create content, travel the world, rest in nature, and catch beautiful moments through the lens of my camera.',
        body2: 'What inspires me: new experiences, beautiful places, mountains, and interesting people along the way.',
        expandCta: 'Get to know me better',
        collapseCta: 'Close',
        longBioLabel: 'THE LONGER STORY',
        instagramTitle: 'Latest Instagram post',
        longBio: [
            "I'm Dominika. I'm inspired by frequent travels, new places, beautiful interiors, nature, and food.",
            "By training I'm a radiographer, but by passion, a content creator and social media manager. I've spent 6+ years working in marketing and social media.",
            'Day to day I work in a medical marketing agency as a social media specialist, and I partner with brands to grow their social or deliver creative content.',
            'My favourite part of the job is making creative pieces for travel, tourism and hotel brands. It fills me with positive energy, I love catching beautiful moments through the frame, playing with light, and preserving stories, emotions and atmosphere on camera.',
            'I approach every project comprehensively, building a mood map and searching for ideas that keep the message authentic.',
            'Discovering new places is my biggest passion, so every trip becomes an adventure full of inspiration.',
            'I love Swiss nature, Italian la dolce vita, I fell for Japanese culture, and I deeply value the cuisine and localness of Poland.',
            'What I value most about this work is that every day offers a new page, and keeps me creatively alive.',
        ],
    },
    services: {
        label: 'SERVICES',
        headlinePre: 'Two ways',
        headlineItalic: 'we can',
        headlinePost: 'work together.',
        ugc: {
            tag: 'Content creation.',
            titlePre: 'Content made',
            titleItalic: 'with',
            titlePost: 'intent.',
            intro: 'Show me what makes your place special, and I’ll capture that magic through the lens.',
            body: 'I create content for hotels, cities, tourist regions, local businesses, restaurants, cafés and product brands.',
            stat: '60+',
            statLabel: 'happy clients',
        },
        manage: {
            tag: 'Social Media Management.',
            titlePre: 'I run',
            titleItalic: 'the whole',
            titlePost: 'feed.',
            intro: "Tell me what your business needs, and I'll run your social media end-to-end.",
            body: 'I take care of your social profiles end-to-end, Instagram, Facebook, LinkedIn, TikTok.',
            stat: '6+ yrs',
            statLabel: 'running social media accounts',
        },
    },
    pricing: {
        label: 'PACKAGES',
        title: 'A few starting packages.',
        sub: 'Pricing is set individually, happy to build a custom offer tailored to you.',
        currency: 'CHF',
        from: 'From',
        items: [
            {
                name: 'Photography',
                price: '600',
                bullets: [
                    'Package of 10–50 edited high-quality photos (count to agree)',
                    'You receive the photos for your own use',
                ],
            },
            {
                name: 'Instagram Photo',
                price: '1200',
                bullets: [
                    'Creative carousel with 5–15 photos (count to agree)',
                    '1 reel or 1 pack of 10 edited high-quality photos',
                ],
            },
            {
                name: 'Instagram Video',
                price: '800',
                bullets: [
                    'Reel 30–45 seconds (number of reels to agree)',
                ],
            },
            {
                name: 'Photo × Travellingdominika',
                price: '600',
                bullets: [
                    "Creative carousel with 5–15 photos, co-published on my {'@'}travellingdominika account",
                ],
            },
        ],
        footer: 'Every offer is individual. Always open to negotiation and a proper chat, drop me a line and we can shape something that fits.',
    },
    realizations: {
        label: 'PROJECTS',
        titlePre: 'I create content that',
        titleItalic: 'tells a story',
        titlePost: 'and engages.',
        body: 'What I love most about my work: every day brings a new page that sparks me creatively.',
        list: [
            { icon: 'camera', label: 'Photography' },
            { icon: 'film', label: 'Short-form video' },
            { icon: 'pen', label: 'Creative copy' },
            { icon: 'pin', label: 'Press trips & place-storytelling' },
            { icon: 'share', label: 'Social media management' },
        ],
        cards: [
            { title: 'Hotels' },
            { title: 'Tourism & travel' },
            { title: 'Food & restaurants' },
            { title: 'Local businesses' },
            { title: 'Product photography' },
            { title: 'Fashion' },
            { title: 'Outdoor' },
        ],
        prev: 'Previous',
        next: 'Next',
    },
    stats: {
        label: 'BY THE NUMBERS',
        title: 'A few years of chasing light.',
        sub: "I don't focus mainly on the numbers, I focus on quality, engaging content. But here's a glimpse of the journey so far.",
        items: [
            { value: '6+', label: 'Years of experience', sub: 'creating content and running social' },
            { value: '60+', label: 'Partnerships', sub: 'clients, brand partners and collabs' },
            { value: '1M+', label: 'Reach', sub: "across {'@'}travellingdominika" },
            { value: '30+', label: 'Countries', sub: 'documented on the road' },
        ],
    },
    portfolio: {
        label: 'PORTFOLIO',
        title: "Places I've wandered.",
        hint: 'drag',
        galleryCta: 'See the full gallery',
        items: [
            { title: 'Kyoto', place: 'Japan' },
            { title: 'Bieszczady', place: 'Poland' },
            { title: 'Harder Kulm', place: 'Switzerland' },
            { title: 'Grindelwald First', place: 'Switzerland' },
            { title: 'Gdańsk', place: 'Poland' },
            { title: 'Lucerne', place: 'Switzerland' },
            { title: 'Como', place: 'Italy' },
            { title: 'Copenhagen', place: 'Denmark' },
            { title: 'Bern', place: 'Switzerland' },
        ],
        closeLabel: 'Close',
        prevLabel: 'Previous photo',
        nextLabel: 'Next photo',
        photoCount: 'photos',
        backLabel: 'Back',
        categoryTaglines: {
            hotels: "hotels I’ve partnered with",
            tourism: "places I’ve travelled",
            products: "brands & products I’ve shot",
        },
        categoryLabels: {
            hotels: 'Hotels',
            tourism: 'Tourism',
            products: 'Product sessions',
        },
        filterLabel: 'Show',
        filterAll: 'All',
        albums: [
            {
                title: "Filario",
                place: "Lake Como, Italy",
                category: "hotels",
                description: "A lakeside design hotel on Lake Como — water-level light, calm interiors and long views across the lake.",
                cover: '/portfolio/filario/1.jpg',
                photos: [
                    '/portfolio/filario/1.jpg',
                    '/portfolio/filario/2.jpg',
                    '/portfolio/filario/3.jpg',
                    '/portfolio/filario/4.jpg',
                    '/portfolio/filario/5.jpg',
                    '/portfolio/filario/6.jpg',
                    '/portfolio/filario/7.jpg',
                    '/portfolio/filario/8.jpg',
                    '/portfolio/filario/9.jpg',
                    '/portfolio/filario/10.jpg',
                    '/portfolio/filario/11.jpg',
                    '/portfolio/filario/12.jpg',
                    '/portfolio/filario/13.jpg',
                    '/portfolio/filario/14.jpg',
                    '/portfolio/filario/15.jpg',
                    '/portfolio/filario/16.jpg',
                    '/portfolio/filario/17.jpg',
                    '/portfolio/filario/18.jpg',
                    '/portfolio/filario/19.jpg',
                    '/portfolio/filario/20.jpg',
                    '/portfolio/filario/21.jpg',
                    '/portfolio/filario/22.jpg',
                    '/portfolio/filario/23.jpg',
                    '/portfolio/filario/24.jpg',
                    '/portfolio/filario/25.jpg',
                    '/portfolio/filario/26.jpg',
                    '/portfolio/filario/27.jpg',
                    '/portfolio/filario/28.jpg',
                    '/portfolio/filario/29.jpg',
                    '/portfolio/filario/30.jpg',
                    '/portfolio/filario/31.jpg',
                    '/portfolio/filario/32.jpg',
                    '/portfolio/filario/33.jpg',
                    '/portfolio/filario/34.jpg',
                    '/portfolio/filario/35.jpg',
                    '/portfolio/filario/36.jpg',
                    '/portfolio/filario/37.jpg',
                    '/portfolio/filario/38.jpg',
                    '/portfolio/filario/39.jpg',
                    '/portfolio/filario/40.jpg',
                    '/portfolio/filario/41.jpg',
                ],
            },
            {
                title: "Guesthouse Castagnola",
                place: "Castagnola, Lugano",
                category: "hotels",
                description: "A boutique guesthouse in Castagnola above Lake Lugano — Mediterranean ease, warm rooms and subtropical gardens.",
                cover: '/portfolio/guesthouse-castagnola/1.jpg',
                photos: [
                    '/portfolio/guesthouse-castagnola/1.jpg',
                    '/portfolio/guesthouse-castagnola/2.jpg',
                    '/portfolio/guesthouse-castagnola/3.jpg',
                    '/portfolio/guesthouse-castagnola/4.jpg',
                    '/portfolio/guesthouse-castagnola/5.jpg',
                    '/portfolio/guesthouse-castagnola/6.jpg',
                    '/portfolio/guesthouse-castagnola/7.jpg',
                    '/portfolio/guesthouse-castagnola/8.jpg',
                    '/portfolio/guesthouse-castagnola/9.jpg',
                    '/portfolio/guesthouse-castagnola/10.jpg',
                    '/portfolio/guesthouse-castagnola/11.jpg',
                    '/portfolio/guesthouse-castagnola/12.jpg',
                    '/portfolio/guesthouse-castagnola/13.jpg',
                    '/portfolio/guesthouse-castagnola/14.jpg',
                    '/portfolio/guesthouse-castagnola/15.jpg',
                    '/portfolio/guesthouse-castagnola/16.jpg',
                    '/portfolio/guesthouse-castagnola/17.jpg',
                    '/portfolio/guesthouse-castagnola/18.jpg',
                    '/portfolio/guesthouse-castagnola/19.jpg',
                    '/portfolio/guesthouse-castagnola/20.jpg',
                    '/portfolio/guesthouse-castagnola/21.jpg',
                    '/portfolio/guesthouse-castagnola/22.jpg',
                    '/portfolio/guesthouse-castagnola/23.jpg',
                    '/portfolio/guesthouse-castagnola/24.jpg',
                ],
            },
            {
                title: "Salotto Brè",
                place: "Brè, Lugano",
                category: "hotels",
                description: "A characterful retreat in the village of Brè above Lugano — rustic Ticinese charm and views over the lake.",
                cover: '/portfolio/salotto-bre/1.jpg',
                photos: [
                    '/portfolio/salotto-bre/1.jpg',
                    '/portfolio/salotto-bre/2.jpg',
                    '/portfolio/salotto-bre/3.jpg',
                    '/portfolio/salotto-bre/4.jpg',
                    '/portfolio/salotto-bre/5.jpg',
                    '/portfolio/salotto-bre/6.jpg',
                    '/portfolio/salotto-bre/7.jpg',
                    '/portfolio/salotto-bre/8.jpg',
                    '/portfolio/salotto-bre/9.jpg',
                    '/portfolio/salotto-bre/10.jpg',
                    '/portfolio/salotto-bre/11.jpg',
                    '/portfolio/salotto-bre/12.jpg',
                    '/portfolio/salotto-bre/13.jpg',
                    '/portfolio/salotto-bre/14.jpg',
                    '/portfolio/salotto-bre/15.jpg',
                ],
            },
            {
                title: "Lugano",
                place: "Lugano, Switzerland",
                category: "tourism",
                description: "Lakeside content across Lugano and Ticino — palm-lined promenades, Mediterranean light and the slow rhythm of the Swiss south.",
                cover: '/portfolio/lugano-tourism/1.jpg',
                photos: [
                    '/portfolio/lugano-tourism/1.jpg',
                    '/portfolio/lugano-tourism/2.jpg',
                    '/portfolio/lugano-tourism/3.jpg',
                    '/portfolio/lugano-tourism/4.jpg',
                    '/portfolio/lugano-tourism/5.jpg',
                    '/portfolio/lugano-tourism/6.jpg',
                    '/portfolio/lugano-tourism/7.jpg',
                    '/portfolio/lugano-tourism/8.jpg',
                    '/portfolio/lugano-tourism/9.jpg',
                    '/portfolio/lugano-tourism/10.jpg',
                    '/portfolio/lugano-tourism/11.jpg',
                    '/portfolio/lugano-tourism/12.jpg',
                    '/portfolio/lugano-tourism/13.jpg',
                    '/portfolio/lugano-tourism/14.jpg',
                    '/portfolio/lugano-tourism/15.jpg',
                    '/portfolio/lugano-tourism/16.jpg',
                    '/portfolio/lugano-tourism/17.jpg',
                    '/portfolio/lugano-tourism/18.jpg',
                    '/portfolio/lugano-tourism/19.jpg',
                    '/portfolio/lugano-tourism/20.jpg',
                    '/portfolio/lugano-tourism/21.jpg',
                    '/portfolio/lugano-tourism/22.jpg',
                    '/portfolio/lugano-tourism/23.jpg',
                    '/portfolio/lugano-tourism/24.jpg',
                    '/portfolio/lugano-tourism/25.jpg',
                    '/portfolio/lugano-tourism/26.jpg',
                    '/portfolio/lugano-tourism/27.jpg',
                    '/portfolio/lugano-tourism/28.jpg',
                    '/portfolio/lugano-tourism/29.jpg',
                    '/portfolio/lugano-tourism/30.jpg',
                    '/portfolio/lugano-tourism/31.jpg',
                    '/portfolio/lugano-tourism/32.jpg',
                    '/portfolio/lugano-tourism/33.jpg',
                    '/portfolio/lugano-tourism/34.jpg',
                    '/portfolio/lugano-tourism/35.jpg',
                    '/portfolio/lugano-tourism/36.jpg',
                    '/portfolio/lugano-tourism/37.jpg',
                    '/portfolio/lugano-tourism/38.jpg',
                    '/portfolio/lugano-tourism/39.jpg',
                    '/portfolio/lugano-tourism/40.jpg',
                    '/portfolio/lugano-tourism/41.jpg',
                    '/portfolio/lugano-tourism/42.jpg',
                    '/portfolio/lugano-tourism/43.jpg',
                    '/portfolio/lugano-tourism/44.jpg',
                    '/portfolio/lugano-tourism/45.jpg',
                    '/portfolio/lugano-tourism/46.jpg',
                    '/portfolio/lugano-tourism/47.jpg',
                    '/portfolio/lugano-tourism/48.jpg',
                    '/portfolio/lugano-tourism/49.jpg',
                    '/portfolio/lugano-tourism/50.jpg',
                    '/portfolio/lugano-tourism/51.jpg',
                    '/portfolio/lugano-tourism/52.jpg',
                    '/portfolio/lugano-tourism/53.jpg',
                    '/portfolio/lugano-tourism/54.jpg',
                    '/portfolio/lugano-tourism/55.jpg',
                    '/portfolio/lugano-tourism/56.jpg',
                    '/portfolio/lugano-tourism/57.jpg',
                    '/portfolio/lugano-tourism/58.jpg',
                    '/portfolio/lugano-tourism/59.jpg',
                    '/portfolio/lugano-tourism/60.jpg',
                ],
            },
            {
                title: "Eiger Lodge",
                place: "Grindelwald, Switzerland",
                category: "hotels",
                description: "A boutique alpine lodge under the Eiger. Warm interiors, mountain views and quiet morning light.",
                cover: '/portfolio/eiger-lodge/1.jpg',
                photos: [
                    '/portfolio/eiger-lodge/1.jpg',
                    '/portfolio/eiger-lodge/2.jpg',
                    '/portfolio/eiger-lodge/3.jpg',
                    '/portfolio/eiger-lodge/4.jpg',
                    '/portfolio/eiger-lodge/5.jpg',
                    '/portfolio/eiger-lodge/6.jpg',
                    '/portfolio/eiger-lodge/7.jpg',
                    '/portfolio/eiger-lodge/8.jpg',
                    '/portfolio/eiger-lodge/9.jpg',
                ],
            },
            {
                title: "Giardino Lago",
                place: "Locarno, Switzerland",
                category: "hotels",
                description: "A boutique hotel above Lake Maggiore, light on water and interiors designed for stillness.",
                cover: '/portfolio/giardino-lago/15.jpg',
                photos: [
                    '/portfolio/giardino-lago/1.jpg',
                    '/portfolio/giardino-lago/2.jpg',
                    '/portfolio/giardino-lago/3.jpg',
                    '/portfolio/giardino-lago/4.jpg',
                    '/portfolio/giardino-lago/5.jpg',
                    '/portfolio/giardino-lago/6.jpg',
                    '/portfolio/giardino-lago/7.jpg',
                    '/portfolio/giardino-lago/8.jpg',
                    '/portfolio/giardino-lago/9.jpg',
                    '/portfolio/giardino-lago/10.jpg',
                    '/portfolio/giardino-lago/11.jpg',
                    '/portfolio/giardino-lago/12.jpg',
                    '/portfolio/giardino-lago/13.jpg',
                    '/portfolio/giardino-lago/14.jpg',
                    '/portfolio/giardino-lago/15.jpg',
                    '/portfolio/giardino-lago/16.jpg',
                ],
            },
            {
                title: "Giardino Ascona",
                place: "Ascona, Switzerland",
                category: "hotels",
                description: "Ascona classic, patios with olive trees, Mediterranean detail, and slow afternoons.",
                cover: '/portfolio/giardino-ascona/1.jpg',
                photos: [
                    '/portfolio/giardino-ascona/1.jpg',
                    '/portfolio/giardino-ascona/2.jpg',
                    '/portfolio/giardino-ascona/3.jpg',
                    '/portfolio/giardino-ascona/4.jpg',
                    '/portfolio/giardino-ascona/5.jpg',
                    '/portfolio/giardino-ascona/6.jpg',
                    '/portfolio/giardino-ascona/7.jpg',
                    '/portfolio/giardino-ascona/8.jpg',
                    '/portfolio/giardino-ascona/9.jpg',
                    '/portfolio/giardino-ascona/10.jpg',
                    '/portfolio/giardino-ascona/11.jpg',
                    '/portfolio/giardino-ascona/12.jpg',
                    '/portfolio/giardino-ascona/13.jpg',
                ],
            },
            {
                title: "Lucerne",
                place: "Switzerland",
                category: "tourism",
                description: "Lucerne in summer light, the lake, the wooden bridges and the Alps just behind.",
                cover: '/portfolio/lucerne/1.jpg',
                photos: [
                    '/portfolio/lucerne/1.jpg',
                    '/portfolio/lucerne/2.jpg',
                    '/portfolio/lucerne/3.jpg',
                    '/portfolio/lucerne/4.jpg',
                    '/portfolio/lucerne/5.jpg',
                    '/portfolio/lucerne/6.jpg',
                    '/portfolio/lucerne/7.jpg',
                    '/portfolio/lucerne/8.jpg',
                ],
            },
            {
                title: "Kulturhof Hinter Musegg",
                place: "Lucerne, Switzerland",
                category: "tourism",
                description: "A session at the historic Kulturhof Hinter Musegg, atmosphere, detail, natural light.",
                cover: '/portfolio/kulturhof/1.jpg',
                photos: [
                    '/portfolio/kulturhof/1.jpg',
                    '/portfolio/kulturhof/2.jpg',
                    '/portfolio/kulturhof/3.jpg',
                    '/portfolio/kulturhof/4.jpg',
                    '/portfolio/kulturhof/5.jpg',
                    '/portfolio/kulturhof/6.jpg',
                    '/portfolio/kulturhof/7.jpg',
                    '/portfolio/kulturhof/8.jpg',
                    '/portfolio/kulturhof/9.jpg',
                    '/portfolio/kulturhof/10.jpg',
                    '/portfolio/kulturhof/11.jpg',
                    '/portfolio/kulturhof/12.jpg',
                ],
            },
            {
                title: "Ascona",
                place: "Ticino, Switzerland",
                category: "tourism",
                description: "The old streets of Ascona on Lake Maggiore, pastel colours and the taste of a Ticino summer.",
                cover: '/portfolio/ascona/1.jpg',
                photos: [
                    '/portfolio/ascona/1.jpg',
                    '/portfolio/ascona/2.jpg',
                    '/portfolio/ascona/3.jpg',
                    '/portfolio/ascona/4.jpg',
                    '/portfolio/ascona/5.jpg',
                    '/portfolio/ascona/6.jpg',
                    '/portfolio/ascona/7.jpg',
                    '/portfolio/ascona/8.jpg',
                    '/portfolio/ascona/9.jpg',
                    '/portfolio/ascona/10.jpg',
                    '/portfolio/ascona/11.jpg',
                    '/portfolio/ascona/12.jpg',
                ],
            },
            {
                title: "Locarno",
                place: "Ticino, Switzerland",
                category: "tourism",
                description: "Locarno in summer light, Piazza Grande, the lake, and the southern Swiss mood.",
                cover: '/portfolio/locarno/1.jpg',
                photos: [
                    '/portfolio/locarno/1.jpg',
                    '/portfolio/locarno/2.jpg',
                    '/portfolio/locarno/3.jpg',
                    '/portfolio/locarno/4.jpg',
                    '/portfolio/locarno/5.jpg',
                    '/portfolio/locarno/6.jpg',
                    '/portfolio/locarno/7.jpg',
                    '/portfolio/locarno/8.jpg',
                ],
            },
            {
                title: "Jungfraujoch",
                place: "Bernese Oberland",
                category: "tourism",
                description: "The Top of Europe. Glaciers, ice tunnels and the wide white silence above the clouds.",
                cover: '/portfolio/jungfraujoch/1.jpg',
                photos: [
                    '/portfolio/jungfraujoch/1.jpg',
                    '/portfolio/jungfraujoch/2.jpg',
                    '/portfolio/jungfraujoch/3.jpg',
                    '/portfolio/jungfraujoch/4.jpg',
                    '/portfolio/jungfraujoch/5.jpg',
                    '/portfolio/jungfraujoch/6.jpg',
                    '/portfolio/jungfraujoch/7.jpg',
                    '/portfolio/jungfraujoch/8.jpg',
                    '/portfolio/jungfraujoch/9.jpg',
                ],
            },
            {
                title: "Harder Kulm",
                place: "Bernese Oberland",
                category: "tourism",
                description: "The viewpoint above Interlaken, Eiger, Mönch and Jungfrau panorama.",
                cover: '/portfolio/harder-kulm/1.jpg',
                photos: [
                    '/portfolio/harder-kulm/1.jpg',
                    '/portfolio/harder-kulm/2.jpg',
                    '/portfolio/harder-kulm/3.jpg',
                    '/portfolio/harder-kulm/4.jpg',
                    '/portfolio/harder-kulm/5.jpg',
                    '/portfolio/harder-kulm/6.jpg',
                    '/portfolio/harder-kulm/7.jpg',
                    '/portfolio/harder-kulm/8.jpg',
                ],
            },
            {
                title: "Grindelwald First",
                place: "Bernese Oberland",
                category: "tourism",
                description: "Up in the Bernese Alps, trails, the gondola and views that stop you in your tracks.",
                cover: '/portfolio/grindelwald-first/1.jpg',
                photos: [
                    '/portfolio/grindelwald-first/1.jpg',
                    '/portfolio/grindelwald-first/2.jpg',
                    '/portfolio/grindelwald-first/3.jpg',
                    '/portfolio/grindelwald-first/4.jpg',
                ],
            },
            {
                title: "Bern",
                place: "Switzerland",
                category: "tourism",
                description: "The Swiss capital in autumn light, arcades, the Aare river and atmospheric streets.",
                cover: '/portfolio/bern/1.jpg',
                photos: [
                    '/portfolio/bern/1.jpg',
                    '/portfolio/bern/2.jpg',
                    '/portfolio/bern/3.jpg',
                    '/portfolio/bern/4.jpg',
                    '/portfolio/bern/5.jpg',
                    '/portfolio/bern/6.jpg',
                    '/portfolio/bern/7.jpg',
                    '/portfolio/bern/8.jpg',
                    '/portfolio/bern/9.jpg',
                    '/portfolio/bern/10.jpg',
                    '/portfolio/bern/11.jpg',
                    '/portfolio/bern/12.jpg',
                ],
            },
            {
                title: "Algarve",
                place: "Portugal",
                category: "tourism",
                description: "Cliffs, ocean and Algarve coastline light, framed like a postcard.",
                cover: '/portfolio/algarve/1.jpg',
                photos: [
                    '/portfolio/algarve/1.jpg',
                    '/portfolio/algarve/2.jpg',
                    '/portfolio/algarve/3.jpg',
                    '/portfolio/algarve/4.jpg',
                    '/portfolio/algarve/5.jpg',
                    '/portfolio/algarve/6.jpg',
                    '/portfolio/algarve/7.jpg',
                    '/portfolio/algarve/8.jpg',
                ],
            },
            {
                title: "Veoli Botanica",
                place: "Product session",
                category: "products",
                description: "A session for the Polish botanical skincare brand Veoli, natural palette and clean frames.",
                cover: '/portfolio/veoli-botanica/1.jpg',
                photos: [
                    '/portfolio/veoli-botanica/1.jpg',
                    '/portfolio/veoli-botanica/2.jpg',
                    '/portfolio/veoli-botanica/3.jpg',
                    '/portfolio/veoli-botanica/4.jpg',
                    '/portfolio/veoli-botanica/5.jpg',
                    '/portfolio/veoli-botanica/6.jpg',
                    '/portfolio/veoli-botanica/7.jpg',
                    '/portfolio/veoli-botanica/8.jpg',
                ],
            },
            {
                title: "Emu",
                place: "Product session",
                category: "products",
                description: "A product session for Emu. Clean light, warm tones and frames that let the product speak.",
                cover: '/portfolio/emu/1.jpg',
                photos: [
                    '/portfolio/emu/1.jpg',
                    '/portfolio/emu/2.jpg',
                    '/portfolio/emu/3.jpg',
                    '/portfolio/emu/4.jpg',
                    '/portfolio/emu/5.jpg',
                    '/portfolio/emu/6.jpg',
                    '/portfolio/emu/7.jpg',
                    '/portfolio/emu/8.jpg',
                    '/portfolio/emu/9.jpg',
                    '/portfolio/emu/10.jpg',
                    '/portfolio/emu/11.jpg',
                ],
            },
            {
                title: "So Bloomy",
                place: "Product session",
                category: "products",
                description: "Product session for So Bloomy. Autumn palette, warm light and frames that build a brand mood.",
                cover: '/portfolio/autumn-product/6.jpg',
                photos: [
                    '/portfolio/autumn-product/1.jpg',
                    '/portfolio/autumn-product/2.jpg',
                    '/portfolio/autumn-product/3.jpg',
                    '/portfolio/autumn-product/4.jpg',
                    '/portfolio/autumn-product/5.jpg',
                    '/portfolio/autumn-product/6.jpg',
                    '/portfolio/autumn-product/7.jpg',
                    '/portfolio/autumn-product/8.jpg',
                ],
            },
            {
                title: "Dilmah",
                place: "Product session",
                category: "products",
                description: "Holiday product session for Dilmah. Warm light, atmosphere and details for hospitality and lifestyle brands.",
                cover: '/portfolio/christmas/2.jpg',
                photos: [
                    '/portfolio/christmas/1.jpg',
                    '/portfolio/christmas/2.jpg',
                    '/portfolio/christmas/3.jpg',
                    '/portfolio/christmas/4.jpg',
                    '/portfolio/christmas/5.jpg',
                    '/portfolio/christmas/6.jpg',
                    '/portfolio/christmas/7.jpg',
                    '/portfolio/christmas/8.jpg',
                ],
            },
            {
                title: "Big Active",
                place: "Product session",
                category: "products",
                description: "A session for Big Active. Tea in a warm composition, mood straight from the leaf.",
                cover: '/portfolio/tea-product/1.jpg',
                photos: [
                    '/portfolio/tea-product/1.jpg',
                    '/portfolio/tea-product/2.jpg',
                    '/portfolio/tea-product/3.jpg',
                    '/portfolio/tea-product/4.jpg',
                    '/portfolio/tea-product/5.jpg',
                    '/portfolio/tea-product/6.jpg',
                    '/portfolio/tea-product/7.jpg',
                    '/portfolio/tea-product/8.jpg',
                ],
            },
        ],
    },
    brands: {
        label: 'I WORKED WITH',
        items: [
            { name: 'Jungfrau Region' },
            { name: 'Taksidi' },
            { name: 'Canon' },
            { name: 'Lucerne Tourism' },
            { name: 'Titlis' },
            { name: 'Grindelwald First' },
            { name: 'Jungfraujoch' },
            { name: 'Eiger Lodge' },
            { name: 'Adelboden-Lenk-Kandersteg' },
            { name: 'Zentralbahn' },
            { name: 'Lake Lucerne' },
            { name: 'Tara Style' },
            { name: 'Dilmah' },
            { name: 'Everest Outdoor' },
            { name: 'Emu Australia' },
            { name: 'Krups' },
        ],
    },
    faq: {
        label: "FAQ",
        title: "Questions, answered.",
        items: [
            { q: "How much does a content shoot in Switzerland cost?",
                a: "Pricing depends entirely on the scale and scope of the project: a single photo set, a full reel package, or end-to-end social media management are all priced differently. Every offer is built around what the brand actually needs, so I'm always happy to put together a custom proposal." },
            { q: "What's included in a content creation package?",
                a: "Most projects include the full creative process: planning a mood and angle for the shoot, photography, short-form video where it fits, editing, and a final delivery you can use across your own channels. Depending on the package, we can also co-publish on {'@'}travellingdominika." },
            { q: "Do you travel for shoots?",
                a: "Yes, anywhere in Switzerland, and I also take on projects in other countries. Travel costs for further locations are quoted transparently as part of the proposal." },
            { q: "What's the difference between content creation and social media management?",
                a: "Content creation means I create the photos, reels and storytelling pieces, and you post them on your own channels. Social media management means I take care of your profiles end-to-end: planning, posting, captions, response handling, the whole feed across Instagram, Facebook, LinkedIn or TikTok." },
            { q: "How long does a hotel or restaurant shoot usually take?",
                a: "A focused half-day on location is enough for most boutique hotels or restaurants. Larger properties or multi-deliverable shoots typically run a full day or two. Editing and delivery follow within one to two weeks." },
            { q: "Can I use the photos and reels on my own channels?",
                a: "Yes. Photography and reel packages come with usage rights for your own brand channels, website and marketing materials. Specific exclusivity or paid-media usage can be agreed up front." },
            { q: "Do you also produce short-form video, Reels and TikTok content?",
                a: "Yes, short-form video is a core part of what I do. Reel packages include 30 to 45 second pieces, and I can also build a recurring rhythm of weekly or monthly reels alongside still photography." },
            { q: "Do you work with restaurants, tourism boards and product brands as well as hotels?",
                a: "Yes. Most of my work is with hotels and hospitality, but I also create content for tourism regions, restaurants and cafés, local businesses, and product brands. Recent product clients include Veoli Botanica, So Bloomy, Dilmah and Big Active." },
            { q: "How far in advance should I book a session?",
                a: "Two to four weeks of lead time is ideal so we can plan the mood, location and timing properly. In peak seasons like summer in Ticino or winter in the Bernese Oberland, earlier is better." },
        ],
    },
    seo: {
        home: {
            title: "Swiss hotel & tourism content creator",
            description: "I'm Dominika, content creator and photographer based in Switzerland. I shoot for hotels, tourism boards and brands. Photography, reels, social.",
        },
        portfolio: {
            title: "Portfolio · Hotels, tourism and product photography in Switzerland",
            description: "Selected photography and content work across Switzerland: hotels, tourism, and product brand sessions by Dominika.",
        },
        hotels: {
            title: "Hotel content creator Switzerland · Portfolio",
            description: "Hotel content shoots and partnerships across Switzerland. Boutique hospitality photography by Dominika.",
        },
        tourism: {
            title: "Swiss tourism photography & travel content · Portfolio",
            description: "Tourism, travel and destination content from across Switzerland: Ticino, Lucerne, the Bernese Oberland and beyond.",
        },
        products: {
            title: "Product photography & brand content · Portfolio",
            description: "Product photography sessions for skincare, food and lifestyle brands. Recent clients include Veoli Botanica, So Bloomy, Dilmah and Big Active.",
        },
        privacy: {
            title: "Privacy Policy",
            description: "How travellingdominika.com handles your data: no cookies, no tracking, no analytics.",
        },
    },
    contact: {
        label: 'CONTACT',
        title: "Let's find out what I can do for you.",
        sub: 'Write me, I reply to every message.',
        email: "dominikatrunowicz{'@'}gmail.com",
        cta: 'Write to me',
    },
    privacy: {
        label: 'PRIVACY',
        title: 'Privacy Policy',
        updated: 'Last updated: June 2026',
        intro: 'This site is my personal portfolio. I keep it simple and collect as little as possible — here is what that means in practice.',
        sections: [
            {
                heading: 'No cookies, no tracking',
                body: 'travellingdominika.com uses no cookies, no analytics, and no third-party tracking. Nothing about your visit is stored or profiled.',
            },
            {
                heading: 'Hosting',
                body: "The site is served as static files through Cloudflare, which may process basic technical request data (such as your IP address) to deliver pages and guard against abuse. See Cloudflare's own privacy policy for details.",
            },
            {
                heading: 'Email contact',
                body: 'If you email me, I use your message and address only to reply to you. I do not add you to any list or share your details with anyone.',
            },
            {
                heading: 'Social links',
                body: 'Links to Instagram and LinkedIn take you to those platforms, which have their own privacy policies.',
            },
            {
                heading: 'Questions',
                body: 'Any questions about your data? Just write to me:',
            },
        ],
    },
    footer: {
        contactLabel: 'CONTACT',
        email: "dominikatrunowicz{'@'}gmail.com",
        responseTime: 'I reply within 24h.',
        socialLabel: 'SOCIAL',
        instagramLabel: 'Instagram',
        instagramUrl: 'https://instagram.com/travellingdominika',
        linkedinLabel: 'LinkedIn',
        linkedinUrl: 'https://www.linkedin.com/in/dominika-trunowicz-317403274/',
        copyright: '© 2026 travellingdominika',
        privacy: 'Privacy Policy',
        privacyUrl: '#privacy',
    },
};
